import React, { useContext } from "react";
import PropTypes from "prop-types";
import {
    ControlledPopup,
    EllipsisDropdown,
    OnHoverOnClick,
    Person,
    Table,
    USER_PERMISSIONS,
} from "dyl-components";
import { Checkbox, DropdownItem, Header } from "semantic-ui-react";
import {
    KEY_CATEGORY_NAME,
    KEY_CREATED_BY,
    KEY_DESCRIPTION,
    KEY_ACTIONS,
    KEY_TAGGED_CALLS,
} from "../contants";
import SubRow from "./SubRow";
import { useState } from "react";
import { Link } from "react-router-dom";
import { BulkActionsContext } from "shared/context/BulkActionsProvider";
import HoverContent from "shared/hoverContent";
import {
    KEY_CALL_TAGS,
    KEY_CONTACT_ACCOUNT,
    KEY_DATE,
    KEY_DESTINATION,
    KEY_DIRECTION,
    KEY_DURATION,
    KEY_NOTE,
    KEY_PHONE_NUMBER,
    KEY_SYSTEM_RESULT,
    KEY_USER,
} from "shared/constants/CALL_HISTORY_LOGS_COLUMNS";
import RestrictedView from "shared/RestrictedView";

const callHistoryColumns = [
    KEY_DATE,
    KEY_CONTACT_ACCOUNT,
    KEY_PHONE_NUMBER,
    KEY_USER,
    KEY_DURATION,
    KEY_ACTIONS,
    KEY_DIRECTION,
    KEY_SYSTEM_RESULT,
    KEY_DESTINATION,
    KEY_NOTE,
    KEY_CALL_TAGS,
];

const Row = ({ record, isColumnHidden, onEdit, onDelete }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [selectedRows, setSelectedRows] = useContext(BulkActionsContext);

    const isSelected = (id) => {
        return selectedRows?.includes?.(id);
    };

    const onToggleContact = (category_id) => {
        const newSelectedContacts = isSelected(category_id)
            ? selectedRows?.filter?.((id) => category_id !== id)
            : [...selectedRows, category_id];
        setSelectedRows(newSelectedContacts);
    };

    const handleToggle = async () => {
        setIsCollapsed(!isCollapsed);
    };
    return (
        <Table.CollapsibleRow
            onToggle={handleToggle}
            collapsed={isCollapsed}
            togglePos={1}
            subrowContent={
                record?.tags?.length > 0 && (
                    <Table.CollapsibleRowContent>
                        <SubRow record={record} />
                    </Table.CollapsibleRowContent>
                )
            }
            toggleDisabled={record?.tags?.length === 0}
        >
            <Table.Cell>
                <Checkbox
                    checked={isSelected(record?.id)}
                    onChange={() => onToggleContact(record?.id)}
                />
            </Table.Cell>
            {!isColumnHidden(KEY_CATEGORY_NAME) && (
                <Table.Cell>{record?.category}</Table.Cell>
            )}
            {!isColumnHidden(KEY_DESCRIPTION) && (
                <Table.Cell>{record?.description}</Table.Cell>
            )}
            {!isColumnHidden(KEY_CREATED_BY) && (
                <Table.Cell>
                    <OnHoverOnClick
                        hoverContent={
                            <HoverContent
                                user={record?.created_by}
                            />
                        }
                        clickable={false}
                        trigger={
                            <Person
                                username={`${record?.created_by?.first_name} ${record?.created_by?.last_name}`}
                                email={record?.created_by?.email}
                                isInactiveUser={!record?.created_by?.active}
                                popup={false}
                            />
                        }
                    />
                </Table.Cell>
            )}
            {!isColumnHidden(KEY_TAGGED_CALLS) && (
                <Table.Cell>
                    <Link
                        to={
                            record?.tags?.length > 0
                                ? `/call-history?tags=${encodeURIComponent(
                                      record?.tags
                                          ?.map?.((tag) => tag?.id)
                                          ?.join?.(",")
                                  )}&columns=${encodeURIComponent(
                                      callHistoryColumns
                                  )}`
                                : "/call-history"
                        }
                    >
                        {record?.tagged_calls ?? 0}
                    </Link>
                </Table.Cell>
            )}
            {!isColumnHidden(KEY_ACTIONS) && (
                <Table.Cell>
                    <EllipsisDropdown>
                        <RestrictedView userPermission={USER_PERMISSIONS.LIBRARY_EDIT} type='disabled'>
                        <DropdownItem
                            text={"Edit"}
                            icon={"fa-solid fa-pencil"}
                            onClick={() => onEdit?.(record)}
                        />
                        </RestrictedView>
                        <RestrictedView userPermission={USER_PERMISSIONS.LIBRARY_DELETE} type='controlledPopupDisabled'>
                        <ControlledPopup
                            header={
                                <Header as="h4" textAlign="center">
                                    Are you sure?
                                    <Header.Subheader style={{ marginTop: 5 }}>
                                        You cannot undo delete actions. <br />
                                        All sub-tags will be deleted.
                                    </Header.Subheader>
                                </Header>
                            }
                            trigger={
                                <DropdownItem
                                    text={"Delete"}
                                    icon={"fa-solid fa-trash"}
                                />
                            }
                            onConfirm={() => onDelete?.(record)}
                            inverted
                        />
                        </RestrictedView>
                    </EllipsisDropdown>
                </Table.Cell>
            )}
        </Table.CollapsibleRow>
    );
};

Row.propTypes = {
    record: PropTypes.object.isRequired,
    isColumnHidden: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default Row;
